// extracted by mini-css-extract-plugin
module.exports = {"header":"MonthlyRevisionsList__header--2RQaf"};